import React, { Component } from 'react';
import './style.scss';
import PageHeader from '../../components/page-header';
import { map } from 'lodash';
import GridItem from '../../components/grid-item';
import BottomMenu from '../../components/bottom-menu';
import { Search, Inbox, Pets, AccountCircleOutlined } from '@material-ui/icons';
import axios from 'axios';
import Button from '../../components/button'
export default class GridListView extends Component {
    state = {
        pets: []
    }

    getPets() {
        let email = localStorage.getItem('user_email');
        axios.get('https://mascota-api.herokuapp.com/pet-list', { params: { "email": email } }, { headers: { 'Content-Type': 'application/json', } }).then(response => {
            let pets = [];

            /*       map(response.data, pet => {
                      axios.get(`https://dog.ceo/api/breed/${pet.breed}/images/random`).then(results => {
                          let processed_pet = pet;
                          Object.assign(processed_pet, { picture: results.data.message });
                          pets.push(processed_pet)
                      }).catch(err => console.log(err))
                  }) */

            console.log(pets)
            this.setState({ pets: response.data }, () => this.getPetImages())
        }).catch(err => console.log(err))
    }

    getPetImages() {
        axios.get('https://dog.ceo/api/breed/boxer/images/random').then(results => {
            let pets = map(this.state.pets, (item, index) => {
                Object.assign(item, { picture: results.data.message })
                return item;
            });
            this.setState({ pets })

        }).catch(err => console.log(err))
    }

    componentDidMount() {
        this.getPets();
    }

    render() {
        return (
            <div className='grid-view'>
                <PageHeader text='Available pets' history={this.props.history} />
                <div className="suggested-breeds-container">
                    {map(this.state.pets, (pet, index) => <GridItem pet={pet} key={index} />)}
                </div>
                <div className="controls">
                    <Button text='Add a pet' action={() => this.props.history.push('/add-pet')} />
                </div>

                <BottomMenu menu_items={[
                    { path: '/pet-borrower', link_name: 'Find borrower', icon: <Search /> },
                    { path: '/grid-view', link_name: 'My pets', icon: <Pets /> },
                    { path: '/pet-owner', link_name: 'Me', icon: <AccountCircleOutlined /> }
                ]} />
            </div>
        );
    }
}
